import { createSelector, createFeatureSelector } from '@ngrx/store';

import { LanguageState } from '@models/index';

export const languageSelector = createFeatureSelector<LanguageState>('language');
export const getLanguageSelector = createSelector(languageSelector, (state: LanguageState) => state); 
export const getLanguageListSelector = createSelector(languageSelector, (state: LanguageState) => state.data); 
